import { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiLogin, apiMe, apiLogout, apiRegister, setStaffToken, getStaffToken } from '@/lib/staffApi';

const AuthContext = createContext(null);

/**
 * Provides the currently logged-in staff user (or null). Bootstrap calls
 * /api/auth/me with the persisted token; on 401 the token is dropped.
 */
export function StaffAuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=anon

  const refresh = useCallback(async () => {
    if (!getStaffToken()) { setUser(null); return; }
    try { setUser(await apiMe()); }
    catch { setStaffToken(null); setUser(null); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const login = async (email, password) => {
    const { token, user: u } = await apiLogin(email, password);
    setStaffToken(token); setUser(u);
    return u;
  };
  const register = async (name, email, password, pin) => {
    const { token, user: u } = await apiRegister(name, email, password, pin);
    setStaffToken(token); setUser(u);
    return u;
  };
  const logout = async () => { try { await apiLogout(); } catch { /* ignore */ } setStaffToken(null); setUser(null); };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, refresh, loading: user === undefined }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useStaffAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useStaffAuth must be used inside StaffAuthProvider');
  return ctx;
}
